import { ColorType } from '@affstore-ds/uikit/dist/lib/atoms/colors/config/types'

export const mapLevelNameToColors = (levelName?: string): [ColorType, string] => {
  switch (levelName) {
    case 'levels-1': {
      return ['black.0', '#B1E400']
    }
    case 'levels-2': {
      return ['white.0', '#3F42F6']
    }
    case 'levels-3': {
      return ['white.0', '#9747FF']
    }
    case 'levels-4': {
      return ['black.0', '#FFD92F']
    }
    case 'levels-5': {
      return ['brand.4', '#201E1F']
    }
    default: {
      return ['black.0', '#B1E400']
    }
  }
}
